module.exports = __webpack_public_path__ + "images/rich_heading/hobby_fashion/trading_card/icon_7bc590cf87e70f256240e50cbb074137.png";